var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconProtectionConsultationWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shield",
    transform: "translate(-0.348)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    className: "st0",
    d: "M175.2,41.6L104.6,7c-1.1-0.6-2.5-0.6-3.6,0L30.4,41.5c-1.4,0.7-2.3,2.1-2.3,3.6v66.1 c0.3,9.4,2.9,18.5,7.4,26.7c4.2,8.4,10.4,15.6,18,21.1l47.1,32.1c1.4,0.9,3.2,0.9,4.6,0l47.1-32.1c14.2-9.7,25.4-30.7,25.4-47.8 v-66C177.5,43.7,176.6,42.3,175.2,41.6z M169.5,111.3c0,14.5-9.8,33-21.8,41.1l-44.8,30.5L58,152.4c-11.8-8-21.8-26.9-21.8-41.1 V47.7l66.7-32.6l66.7,32.7L169.5,111.3L169.5,111.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    className: "st0",
    d: "M51.7,99.2c0,28.2,22.9,51.1,51.1,51.1s51.1-22.9,51.1-51.1S131,48.1,102.8,48.1l0,0 C74.6,48.1,51.7,71,51.7,99.2z M102.8,56.2c23.8,0,43,19.3,43,43s-19.3,43-43,43s-43-19.3-43-43l0,0 C59.8,75.5,79.1,56.2,102.8,56.2L102.8,56.2L102.8,56.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    className: "st0",
    d: "M76.6,102.9c0,2.2,1.8,4,4,4l0,0h4.1c5.1,13.5,20.3,20.4,33.8,15.2h0.1c2.1-0.8,3.1-3.2,2.2-5.3 c-0.8-2-3.1-3-5.1-2.3c-8.2,3.2-17.6,0-22.1-7.6h17.3c2.2-0.1,4-1.9,3.9-4.1s-1.8-3.9-3.9-3.9H91.1c0-0.5,0-1.1,0-1.6h22.2 c2.2-0.1,4-1.9,3.9-4.1s-1.8-3.9-3.9-3.9H93.2c4.3-8.1,14-11.7,22.6-8.4c2.1,0.8,4.4-0.3,5.2-2.4c0.8-2-0.3-4.3-2.3-5.1 c-13.5-5.2-28.7,1.5-33.9,15c-0.1,0.3-0.2,0.6-0.4,1h-3.8c-2.2-0.1-4.1,1.7-4.1,3.9c-0.1,2.2,1.7,4.1,3.9,4.1c0.1,0,0.1,0,0.2,0H83 c0,0.5,0,1.1,0,1.6h-2.4C78.4,98.8,76.6,100.6,76.6,102.9z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProtectionConsultationWhite);
export default __webpack_public_path__ + "static/media/Icon_Protection_consultation_white.4428ac84793e3d4eb4bafab2053caff9.svg";
export { ForwardRef as ReactComponent };